import Com from "components/styledComp/CommStyledComp";
import React from "react";

//Marina Facility Management System
const SMIMS = () => {
    return(
        <Com.DivDetailSection border={false}>
            <Com.DivDetailHeading>
                <Com.DetailHeading>Marina Facility Management System</Com.DetailHeading>
                <Com.DetailHeadingP>MaFims</Com.DetailHeadingP>
                <Com.DivDetailHeading>
                    <div className="paragraph">
                        sDevice가 장착된 Pedestal과 연결하여 원격 제어및 검침 통합 관리
                        <br/>선석관리시스템을 포함하는 마리나 시설 관리 시스템
                    </div>
                </Com.DivDetailHeading>
            </Com.DivDetailHeading>
            <div className="strategy">
                <Com.StrongStrategy>MaFims 주요기능</Com.StrongStrategy>
            </div>
            <div className="op_content">
                <Com.OlBangHyang>
                    <li>
                        <div className="test">
                            <Com.POpWay>페데스탈제어</Com.POpWay>
                            <Com.OlInOl>
                                <li>수도/전기/조명 제어</li>
                                <li>조명 일괄 ON/OFF</li>
                                <li>페데스탈 상태 확인</li>
                                <li>펌웨어 자동 업데이트</li>
                                <li>페데스탈 이름 확인</li>
                            </Com.OlInOl>
                        </div>
                    </li>
                    <li>
                        <div className="test">
                            <Com.POpWay>선석 관리</Com.POpWay>
                            <Com.OlInOl>
                                <li>선석 판매 현황</li>
                                <li>선석 상태 대시보드</li>
                                <li>다양한 검색 조건</li>
                                <li>선석별 현황</li>
                                <li>만기 선석 확인</li>
                            </Com.OlInOl>
                        </div>
                    </li>
                    <li>
                        <div className="test">
                            <Com.POpWay>고객관리(선주)</Com.POpWay>
                            <Com.OlInOl>
                                <li>고객 등록/수정/삭제</li>
                                <li>개인/법인 구분 관리</li>
                                <li>연락처(e-mail/전화)를 통한 메시지 전송</li>
                            </Com.OlInOl>
                        </div>
                    </li>
                    <li>
                        <div className="test">
                        <Com.POpWay>선박관리</Com.POpWay>
                        <Com.OlInOl>
                            <li>선박 등록/수정/삭제</li>
                            <li>고객-선박 정보 연계</li>
                            <li>선석 사용 내역 확인</li>
                        </Com.OlInOl>
                        </div>
                    </li>
                    <li>
                    <div className="test">
                        <Com.POpWay>공지사항</Com.POpWay>
                        <Com.OlInOl>
                            <li>공지 등록/수정/삭제</li>
                            <li>공지 기간 설정</li>
                            <li>조회수 확인</li>
                        </Com.OlInOl>
                        </div>
                    </li>
                    <li>
                    <div className="test">
                        <Com.POpWay>사용자관리</Com.POpWay>
                        <Com.OlInOl>
                            <li>사용자 등록/수정/삭제</li>
                            <li>사용자 복원</li>
                            <li>카드 등록(페데스탈/출입문 사용)</li>
                            <li>권한(사용자/관리자)의 설정</li>
                        </Com.OlInOl>
                        </div>
                    </li>
                    <li>
                    <div className="test">
                        <Com.POpWay>상품관리</Com.POpWay>
                        <Com.OlInOl>
                            <li>상품(선석/전기/수도/샤워장) 생성/수정/삭제</li>
                            <li>전기/수도의 단가 설정(페데스탈)</li>
                        </Com.OlInOl>
                        </div>
                    </li>
                    <li>
                    <div className="test">
                        <Com.POpWay>결재관리</Com.POpWay>
                        <Com.OlInOl>
                            <li>사용자별 선불 금액 추가</li>
                            <li>POS와 연계하여 매출 관리(To Be)</li>
                        </Com.OlInOl>
                        </div>
                    </li>
                    <li>
                    <div className="test">
                        <Com.POpWay>매출현황</Com.POpWay>
                        <Com.OlInOl>
                            <li>사용자별/제품별 매출 금액 확인</li>
                            <li>선불 사용금액 및 잔액 현황</li>
                            <li>페데스탈별 사용량, 금액 확인</li>
                        </Com.OlInOl>
                        </div>
                    </li>
                    <li>
                    <div className="test">
                        <Com.POpWay>메시지관리</Com.POpWay>
                        <Com.OlInOl>
                            <li>페데스탈 전원 플러그 빠짐 경고</li>
                            <li>카카오톡 연계</li>
                            <li>잔액/사용량 메시지 전송</li>
                            <li>경고(잔액 부족)</li>
                        </Com.OlInOl>
                        </div>
                    </li>
                    <li>
                    <div className="test">
                        <Com.POpWay>대시보드</Com.POpWay>
                        <Com.OlInOl>
                            <li>주요 관리 정보 설정 후 표시</li>
                        </Com.OlInOl>
                        </div>
                    </li>
                </Com.OlBangHyang>
            </div>
        </Com.DivDetailSection>
    );
}

export default SMIMS;